export const APP_NAME = 'StarZero';

// Add other app-wide constants here as needed
